<template>
  <div>
    <InfuseNote v-if="model?.linkedCentralSystems?.length === 0">
      {{ t('e_connector.chargingStations.noLinkedCentralSystems') }}
    </InfuseNote>

    <ChargingStationDescriptionList :item="model" />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { InfuseNote } from '@infuse/ui/components';
import { ChargingStation } from '@infuse/e-connector/charging-station/domain';
import { ChargingStationDescriptionList } from '@infuse/e-connector/charging-station/ui';

const { t } = useI18n();

interface Props {
  model: ChargingStation;
}
withDefaults(defineProps<Props>(), {});
</script>
